import { Facebook, Twitter, Linkedin, Github } from "lucide-react"
import { useEffect } from "react";
import client from "../../api/client";
import { useState } from "react";
export default function Trainers() {
    // const trainerss = [
    //     {
    //         id: 1,
    //         name: "Jane Daramola",
    //         title: "Senior Data Trainer",
    //         image: image,
    //         bio: "10+ years of experience training at MTN, KPMG, Access Bank. Certified in Microsoft Power BI & Tableau",
    //         socialLinks: {
    //             facebook: "#",
    //             twitter: "#",
    //             linkedin: "#",
    //             github: "#",
    //         },
    //     },
    //     {
    //         id: 2,
    //         name: "David Akinyemi",
    //         title: "Project Management Lead",
    //         image: image,
    //         bio: "PMP certified. Managed training roll outs for 100+ companies across West Africa.",
    //         socialLinks: {
    //             facebook: "#",
    //             twitter: "#",
    //             linkedin: "#",
    //             github: "#",
    //         },
    //     },
    //     {
    //         id: 3,
    //         name: "Tolu Fajobi",
    //         title: "Business Analyst Coach",
    //         image: image,
    //         bio: "Ex-Accenture, now consulting for Fortune 500s. Specializes in hybrid learning delivery.",
    //         socialLinks: {
    //             facebook: "#",
    //             twitter: "#",
    //             linkedin: "#",
    //             github: "#",
    //         },
    //     },
    // ]
//    const TrainersProvider = ({ children }) => {
//     return <TrainersContext.Provider value={trainers}>{children}</TrainersContext.Provider>;
//   };
      const [, setIsLoading] = useState(true);
      const [, setError] = useState(null);
      const [trainers, setTrainers] = useState([]);
    const loadData = async () => {
        setIsLoading(true);
        try {
            // Simulate fetching trainers data
             const res = (await client.get(`/tutors`)).data;
            const raw = res.data;
            setTrainers(Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
        } catch (error) {
            setError(error);
        }
        setIsLoading(false);
    }
     useEffect(() => {
        loadData();
    }, []);

    return (
        <section className="py-16 md:py-[106px] bg-white">
            <div className=" px-6 md:px-20">
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-semibold text-[#181818] mb-10">Meet Our Expert Trainers</h2>
                </div>

                {/* Trainers Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {trainers.map((trainer) => (
                        <div
                            key={trainer.id}
                            className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 group"
                        >
                            {/* Trainer Image */}
                            <div className="relative overflow-hidden">
                                <img
                                    src={trainer.image || "/placeholder.svg?height=300&width=300"}
                                    alt={trainer.name}
                                    className="w-full h-[192px] object-cover group-hover:scale-105 transition-transform duration-300 px-4 pt-4"
                                />
                            </div>

                            {/* Trainer Info */}
                            <div className="py-6 px-4">
                                {/* Name and Title */}
                                <div className="mb-[10px]">
                                    <h3 className="text-xl font-semibold">{trainer.name}</h3>
                                    <p className="text-[#F05A19] font-medium">{trainer.course_title}</p>
                                </div>

                                {/* Bio */}
                                <p className="text-[#6B7280] text-base leading-relaxed mb-4 h-[80px]">{trainer.course_description}</p>

                                {/* Social Links */}
                                <div className="flex gap-3">
                                    <a
                                        href={trainer.facebook_url}
                                        className="w-8 h-8  text-[#6B7280] hover:text-white flex items-center justify-center transition-all duration-200"
                                        aria-label={`${trainer.name} Facebook`}
                                    >
                                        <Facebook size={16} />
                                    </a>
                                    <a
                                        href={trainer.twitter_url}
                                        className="w-8 h-8  text-[#6B7280] hover:text-white flex items-center justify-center transition-all duration-200"
                                        aria-label={`${trainer.name} Twitter`}
                                    >
                                        <Twitter size={16} />
                                    </a>
                                    <a
                                        href={trainer.linkedin_url}
                                        className="w-8 h-8  text-[#6B7280]hover:text-white flex items-center justify-center transition-all duration-200"
                                        aria-label={`${trainer.name} LinkedIn`}
                                    >
                                        <Linkedin size={16} />
                                    </a>
                                    <a
                                        href={trainer.github_url}
                                        className="w-8 h-8  text-[#6B7280] hover:text-white flex items-center justify-center transition-all duration-200"
                                        aria-label={`${trainer.name} GitHub`}
                                    >
                                        <Github size={16} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
